export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') },
	'scrollExperience': { id: 'scrollExperience', page: 'scrollExperience', getter: () => import(/* webpackChunkName: 'scrollExperience' */ 'components/bolt/scrollExperience/scrollExperience') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "synopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' },
	{ id: 'boltWatchMore', getter: () => import(/* webpackChunkName: "watchMore" */ 'components/bolt/watchMore/watchMore'), component: 'watchMore' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
